import { render, staticRenderFns } from "./BuscaBeneficiario.vue?vue&type=template&id=2f762220&scoped=true"
import script from "./BuscaBeneficiario.vue?vue&type=script&lang=js"
export * from "./BuscaBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./BuscaBeneficiario.vue?vue&type=style&index=0&id=2f762220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f762220",
  null
  
)

export default component.exports